import { Box } from "@mui/system";
import "./Style.css";


const MultiTemplateView = () => {

    return (
        <Box className="multiTemplates">
            <h1>MultiTemplateView</h1>
        </Box>
    )
};

export default MultiTemplateView;